import { render, staticRenderFns } from "./DutyCardTitle.vue?vue&type=template&id=431c497a&"
import script from "./DutyCardTitle.vue?vue&type=script&lang=js&"
export * from "./DutyCardTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports